import type { DrawAnswerFragment } from '../../../present/activity-answers.graphql.generated';
import { JSONObject } from 'global/graphql/scalars.type';

export function hasDrawAnswer(
  answer: DrawAnswerFragment | null | undefined
): boolean {
  // If type is "Image" it's a background image
  return !!answer?.drawing?.data?.objects?.some(
    (obj: JSONObject) => obj.type !== 'Image'
  );
}
